import React from 'react';
import { useApiAuth } from '../hooks/useApiAuth';
import { useAuthContext } from '../contexts/AuthProvider';
import { AccessResponse } from '../services/apiService';

interface AccessControlledAppProps {
  children: React.ReactNode;
  onAccessDataReceived?: (accessData: AccessResponse) => void;
  autoCheckAccess?: boolean;
  loadingTimeout?: number;
  requireAccessCheck?: boolean;
}

export const AccessControlledApp: React.FC<AccessControlledAppProps> = ({
  children,
  
}) => {
  const { isAuthenticated } = useAuthContext();

  if (!isAuthenticated) {
    return <>{children}</>;
  }
  return <div>{children}</div>;
};

// Hook to get access data from anywhere in the app
export const useUserAccess = () => {
  const { accessResponse } = useApiAuth();
  
  const hasAccessTo = (appName: string): boolean => {
    return accessResponse?.data?.access[appName]?.access === 'Yes';
  };
  
  const getAppUrl = (appName: string): string | null => {
    return accessResponse?.data?.access[appName]?.url || null;
  };
  
  const getAllowedApps = (): string[] => {
    if (!accessResponse?.data?.access) return [];
    
    return Object.entries(accessResponse.data.access)
      .filter(([_, appAccess]) => appAccess.access === 'Yes')
      .map(([appName, _]) => appName);
  };
  
  return {
    hasAccessTo,
    getAppUrl,
    getAllowedApps,
    accessData: accessResponse?.data,
    isLoading: !accessResponse
  };
};
